import React from 'react'
import { Paper, useTheme } from '@mui/material'
import Text from '../../Text'

// Card de KPI — número em destaque, ícone com cor de acento e legenda. Skeleton
// enquanto carrega. Compartilhado entre o relatório de envios e o do SmartFilter.
export default function KpiCard({ label, value, hint, icon, accent, loading }) {
  const theme = useTheme()
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '14px',
        border: theme.isDark ? '1px solid #334155' : '1px solid #e2e8f0',
        overflow: 'hidden',
        height: '100%',
      }}
    >
      <div className="p-5 flex items-start justify-between gap-3 h-full">
        <div className="min-w-0">
          <Text className="text-xs font-semibold uppercase tracking-wider opacity-50">{label}</Text>
          {
            loading
            ? <div className="mt-2 h-8 w-20 rounded bg-current opacity-10 animate-pulse" />
            : <Text className="text-3xl md:text-4xl font-black mt-1 leading-none" style={{ color: accent }}>
                {typeof value === 'number' ? value.toLocaleString('pt-BR') : value}
              </Text>
          }
          {hint && <Text className="text-xs opacity-40 mt-2 block">{hint}</Text>}
        </div>
        {
          icon &&
          <div
            className="shrink-0 rounded-xl flex items-center justify-center"
            style={{ width: 44, height: 44, background: `${accent}1a`, color: accent }}
          >
            {icon}
          </div>
        }
      </div>
    </Paper>
  )
}
